import { Smartphone } from 'lucide-react';
import toast from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext';
import api, { downloadFile, downloadErrorMessage } from '../../services/api';

// Same roles as LocalServerDownloadMenu — a PIN-authenticated cashier shouldn't
// see an app-install prompt.
const ALLOWED_ROLES = ['manager', 'partner', 'admin', 'super_admin'];

/** Downloads the latest published mobile_pos APK — same manual-drop pattern as LocalServerDownloadMenu. */
export default function MobileApkDownloadButton() {
    const { user } = useAuth();

    if (!user || !ALLOWED_ROLES.includes(user.role)) return null;

    const handleDownload = async () => {
        try {
            const res = await api.get('/mobile-builds/latest');
            const build = res.data.data as { version: string; filename: string } | null;
            if (!build) {
                toast.error("Aucune version de l'application mobile disponible.");
                return;
            }
            await downloadFile(`/mobile-builds/download/${build.filename}`, build.filename);
        } catch (err) {
            toast.error(downloadErrorMessage(err, 'Échec du téléchargement.'));
        }
    };

    return (
        <button
            onClick={handleDownload}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium bg-gray-50 text-gray-700 hover:bg-gray-100 transition-colors"
            title="Télécharger l'application mobile (APK)"
        >
            <Smartphone className="h-3.5 w-3.5" />
            <span className="hidden 2xl:inline">App mobile</span>
        </button>
    );
}
